import { render } from "./CopyClipboard.vue?vue&type=template&id=49dcd3f3&scoped=true"
import script from "./CopyClipboard.vue?vue&type=script&lang=js"
export * from "./CopyClipboard.vue?vue&type=script&lang=js"

import "./CopyClipboard.vue?vue&type=style&index=0&id=49dcd3f3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49dcd3f3"]])

export default __exports__